// @generated by tools/build.py. Do not edit.
import { make } from "./Icon";

export const AArrowDown = /*#__PURE__*/ make("a-arrow-down", "AArrowDown");
export const AArrowUp = /*#__PURE__*/ make("a-arrow-up", "AArrowUp");
export const ALargeSmall = /*#__PURE__*/ make("a-large-small", "ALargeSmall");
export const Accessibility = /*#__PURE__*/ make("accessibility", "Accessibility");
export const Activity = /*#__PURE__*/ make("activity", "Activity");
export const AlarmClock = /*#__PURE__*/ make("alarm-clock", "AlarmClock");
export const AlertCircle = /*#__PURE__*/ make("circle-alert", "AlertCircle");
export const AlertTriangle = /*#__PURE__*/ make("triangle-alert", "AlertTriangle");
export const AlignCenter = /*#__PURE__*/ make("align-center", "AlignCenter");
export const AlignCenterHorizontal = /*#__PURE__*/ make("align-center-horizontal", "AlignCenterHorizontal");
export const AlignCenterVertical = /*#__PURE__*/ make("align-center-vertical", "AlignCenterVertical");
export const AlignEndHorizontal = /*#__PURE__*/ make("align-end-horizontal", "AlignEndHorizontal");
export const AlignEndVertical = /*#__PURE__*/ make("align-end-vertical", "AlignEndVertical");
export const AlignHorizontalDistributeCenter = /*#__PURE__*/ make("align-horizontal-distribute-center", "AlignHorizontalDistributeCenter");
export const AlignHorizontalJustifyCenter = /*#__PURE__*/ make("align-horizontal-justify-center", "AlignHorizontalJustifyCenter");
export const AlignJustify = /*#__PURE__*/ make("align-justify", "AlignJustify");
export const AlignLeft = /*#__PURE__*/ make("align-left", "AlignLeft");
export const AlignRight = /*#__PURE__*/ make("align-right", "AlignRight");
export const AlignStartHorizontal = /*#__PURE__*/ make("align-start-horizontal", "AlignStartHorizontal");
export const AlignStartVertical = /*#__PURE__*/ make("align-start-vertical", "AlignStartVertical");
export const AlignVerticalJustifyCenter = /*#__PURE__*/ make("align-vertical-justify-center", "AlignVerticalJustifyCenter");
export const AlignVerticalJustifyEnd = /*#__PURE__*/ make("align-vertical-justify-end", "AlignVerticalJustifyEnd");
export const AlignVerticalJustifyStart = /*#__PURE__*/ make("align-vertical-justify-start", "AlignVerticalJustifyStart");
export const AppWindow = /*#__PURE__*/ make("app-window", "AppWindow");
export const Archive = /*#__PURE__*/ make("archive", "Archive");
export const ArrowDown = /*#__PURE__*/ make("arrow-down", "ArrowDown");
export const ArrowDownAZ = /*#__PURE__*/ make("arrow-down-a-z", "ArrowDownAZ");
export const ArrowDownFromLine = /*#__PURE__*/ make("arrow-down-from-line", "ArrowDownFromLine");
export const ArrowDownToLine = /*#__PURE__*/ make("arrow-down-to-line", "ArrowDownToLine");
export const ArrowDownUp = /*#__PURE__*/ make("arrow-down-up", "ArrowDownUp");
export const ArrowDownWideNarrow = /*#__PURE__*/ make("arrow-down-wide-narrow", "ArrowDownWideNarrow");
export const ArrowDownZA = /*#__PURE__*/ make("arrow-down-z-a", "ArrowDownZA");
export const ArrowLeft = /*#__PURE__*/ make("arrow-left", "ArrowLeft");
export const ArrowLeftFromLine = /*#__PURE__*/ make("arrow-left-from-line", "ArrowLeftFromLine");
export const ArrowLeftRight = /*#__PURE__*/ make("arrow-left-right", "ArrowLeftRight");
export const ArrowLeftToLine = /*#__PURE__*/ make("arrow-left-to-line", "ArrowLeftToLine");
export const ArrowRight = /*#__PURE__*/ make("arrow-right", "ArrowRight");
export const ArrowRightFromLine = /*#__PURE__*/ make("arrow-right-from-line", "ArrowRightFromLine");
export const ArrowRightLeft = /*#__PURE__*/ make("arrow-right-left", "ArrowRightLeft");
export const ArrowUp = /*#__PURE__*/ make("arrow-up", "ArrowUp");
export const ArrowUpAZ = /*#__PURE__*/ make("arrow-up-az", "ArrowUpAZ");
export const ArrowUpAz = /*#__PURE__*/ make("arrow-up-az", "ArrowUpAz");
export const ArrowUpDown = /*#__PURE__*/ make("arrow-up-down", "ArrowUpDown");
export const ArrowUpFromLine = /*#__PURE__*/ make("arrow-up-from-line", "ArrowUpFromLine");
export const ArrowUpNarrowWide = /*#__PURE__*/ make("arrow-up-narrow-wide", "ArrowUpNarrowWide");
export const ArrowUpRight = /*#__PURE__*/ make("arrow-up-right", "ArrowUpRight");
export const ArrowUpToLine = /*#__PURE__*/ make("arrow-up-to-line", "ArrowUpToLine");
export const AtSign = /*#__PURE__*/ make("at-sign", "AtSign");
export const Ban = /*#__PURE__*/ make("ban", "Ban");
export const Banknote = /*#__PURE__*/ make("banknote", "Banknote");
export const BarChart2 = /*#__PURE__*/ make("chart-column", "BarChart2");
export const BarChart3 = /*#__PURE__*/ make("chart-column", "BarChart3");
export const BarChartHorizontal = /*#__PURE__*/ make("chart-bar", "BarChartHorizontal");
export const Baseline = /*#__PURE__*/ make("baseline", "Baseline");
export const Bell = /*#__PURE__*/ make("bell", "Bell");
export const BellOff = /*#__PURE__*/ make("bell-off", "BellOff");
export const BetweenHorizontalStart = /*#__PURE__*/ make("between-horizontal-start", "BetweenHorizontalStart");
export const BetweenVerticalStart = /*#__PURE__*/ make("between-vertical-start", "BetweenVerticalStart");
export const Binary = /*#__PURE__*/ make("binary", "Binary");
export const Blend = /*#__PURE__*/ make("blend", "Blend");
export const Blocks = /*#__PURE__*/ make("blocks", "Blocks");
export const Bluetooth = /*#__PURE__*/ make("bluetooth", "Bluetooth");
export const Bold = /*#__PURE__*/ make("bold", "Bold");
export const BookA = /*#__PURE__*/ make("book-a", "BookA");
export const BookMarked = /*#__PURE__*/ make("book-marked", "BookMarked");
export const BookOpen = /*#__PURE__*/ make("book-open", "BookOpen");
export const BookText = /*#__PURE__*/ make("book-text", "BookText");
export const Bookmark = /*#__PURE__*/ make("bookmark", "Bookmark");
export const BookmarkCheck = /*#__PURE__*/ make("bookmark-check", "BookmarkCheck");
export const Bot = /*#__PURE__*/ make("bot", "Bot");
export const Box = /*#__PURE__*/ make("box", "Box");
export const BoxSelect = /*#__PURE__*/ make("box-select", "BoxSelect");
export const Boxes = /*#__PURE__*/ make("boxes", "Boxes");
export const Braces = /*#__PURE__*/ make("braces", "Braces");
export const Briefcase = /*#__PURE__*/ make("briefcase", "Briefcase");
export const BringToFront = /*#__PURE__*/ make("bring-to-front", "BringToFront");
export const Brush = /*#__PURE__*/ make("brush", "Brush");
export const Building = /*#__PURE__*/ make("building", "Building");
export const Building2 = /*#__PURE__*/ make("building", "Building2");
export const Cable = /*#__PURE__*/ make("cable", "Cable");
export const Calculator = /*#__PURE__*/ make("calculator", "Calculator");
export const Calendar = /*#__PURE__*/ make("calendar", "Calendar");
export const CalendarCheck = /*#__PURE__*/ make("calendar-check", "CalendarCheck");
export const CalendarCheck2 = /*#__PURE__*/ make("calendar-check", "CalendarCheck2");
export const CalendarClock = /*#__PURE__*/ make("calendar-clock", "CalendarClock");
export const CalendarDays = /*#__PURE__*/ make("calendar-days", "CalendarDays");
export const CalendarPlus = /*#__PURE__*/ make("calendar-plus", "CalendarPlus");
export const CalendarRange = /*#__PURE__*/ make("calendar-range", "CalendarRange");
export const Camera = /*#__PURE__*/ make("camera", "Camera");
export const Captions = /*#__PURE__*/ make("captions", "Captions");
export const CaseSensitive = /*#__PURE__*/ make("case-sensitive", "CaseSensitive");
export const ChartArea = /*#__PURE__*/ make("chart-area", "ChartArea");
export const ChartBar = /*#__PURE__*/ make("chart-bar", "ChartBar");
export const ChartColumn = /*#__PURE__*/ make("chart-column", "ChartColumn");
export const ChartLine = /*#__PURE__*/ make("chart-line", "ChartLine");
export const ChartPie = /*#__PURE__*/ make("chart-pie", "ChartPie");
export const ChartScatter = /*#__PURE__*/ make("chart-scatter", "ChartScatter");
export const Check = /*#__PURE__*/ make("check", "Check");
export const CheckCheck = /*#__PURE__*/ make("check-check", "CheckCheck");
export const CheckCircle = /*#__PURE__*/ make("circle-check", "CheckCircle");
export const CheckCircle2 = /*#__PURE__*/ make("circle-check", "CheckCircle2");
export const CheckSquare = /*#__PURE__*/ make("square-check", "CheckSquare");
export const ChevronDown = /*#__PURE__*/ make("chevron-down", "ChevronDown");
export const ChevronLeft = /*#__PURE__*/ make("chevron-left", "ChevronLeft");
export const ChevronRight = /*#__PURE__*/ make("chevron-right", "ChevronRight");
export const ChevronUp = /*#__PURE__*/ make("chevron-up", "ChevronUp");
export const ChevronsDownUp = /*#__PURE__*/ make("chevrons-down-up", "ChevronsDownUp");
export const ChevronsLeft = /*#__PURE__*/ make("chevrons-left", "ChevronsLeft");
export const ChevronsRight = /*#__PURE__*/ make("chevrons-right", "ChevronsRight");
export const ChevronsUpDown = /*#__PURE__*/ make("chevrons-up-down", "ChevronsUpDown");
export const Circle = /*#__PURE__*/ make("circle", "Circle");
export const CircleAlert = /*#__PURE__*/ make("circle-alert", "CircleAlert");
export const CircleCheck = /*#__PURE__*/ make("circle-check", "CircleCheck");
export const CircleCheckBig = /*#__PURE__*/ make("circle-check", "CircleCheckBig");
export const CircleChevronLeft = /*#__PURE__*/ make("circle-chevron-left", "CircleChevronLeft");
export const CircleChevronRight = /*#__PURE__*/ make("circle-chevron-right", "CircleChevronRight");
export const CircleDashed = /*#__PURE__*/ make("circle-dashed", "CircleDashed");
export const CircleDot = /*#__PURE__*/ make("circle-dot", "CircleDot");
export const CircleHelp = /*#__PURE__*/ make("circle-help", "CircleHelp");
export const CirclePlay = /*#__PURE__*/ make("circle-play", "CirclePlay");
export const CirclePlus = /*#__PURE__*/ make("circle-plus", "CirclePlus");
export const CircleUser = /*#__PURE__*/ make("circle-user", "CircleUser");
export const CircleX = /*#__PURE__*/ make("circle-x", "CircleX");
export const ClipboardCheck = /*#__PURE__*/ make("clipboard-check", "ClipboardCheck");
export const ClipboardList = /*#__PURE__*/ make("clipboard-list", "ClipboardList");
export const ClipboardPaste = /*#__PURE__*/ make("clipboard-paste", "ClipboardPaste");
export const Clock = /*#__PURE__*/ make("clock", "Clock");
export const Cloud = /*#__PURE__*/ make("cloud", "Cloud");
export const CloudAlert = /*#__PURE__*/ make("cloud-alert", "CloudAlert");
export const CloudOff = /*#__PURE__*/ make("cloud-off", "CloudOff");
export const CloudUpload = /*#__PURE__*/ make("cloud-upload", "CloudUpload");
export const Code = /*#__PURE__*/ make("code", "Code");
export const Code2 = /*#__PURE__*/ make("code", "Code2");
export const Columns2 = /*#__PURE__*/ make("columns-2", "Columns2");
export const Columns3 = /*#__PURE__*/ make("columns-3", "Columns3");
export const Combine = /*#__PURE__*/ make("combine", "Combine");
export const Command = /*#__PURE__*/ make("command", "Command");
export const Contrast = /*#__PURE__*/ make("contrast", "Contrast");
export const Copy = /*#__PURE__*/ make("copy", "Copy");
export const CopyPlus = /*#__PURE__*/ make("copy-plus", "CopyPlus");
export const CornerDownRight = /*#__PURE__*/ make("corner-down-right", "CornerDownRight");
export const CornerUpLeft = /*#__PURE__*/ make("corner-up-left", "CornerUpLeft");
export const Cpu = /*#__PURE__*/ make("cpu", "Cpu");
export const Crop = /*#__PURE__*/ make("crop", "Crop");
export const Crosshair = /*#__PURE__*/ make("crosshair", "Crosshair");
export const Crown = /*#__PURE__*/ make("crown", "Crown");
export const Database = /*#__PURE__*/ make("database", "Database");
export const Delete = /*#__PURE__*/ make("delete", "Delete");
export const Disc = /*#__PURE__*/ make("disc", "Disc");
export const DoorOpen = /*#__PURE__*/ make("door-open", "DoorOpen");
export const Download = /*#__PURE__*/ make("download", "Download");
export const Droplet = /*#__PURE__*/ make("droplet", "Droplet");
export const Droplets = /*#__PURE__*/ make("droplets", "Droplets");
export const Earth = /*#__PURE__*/ make("earth", "Earth");
export const Ellipsis = /*#__PURE__*/ make("ellipsis", "Ellipsis");
export const EllipsisVertical = /*#__PURE__*/ make("ellipsis-vertical", "EllipsisVertical");
export const Eraser = /*#__PURE__*/ make("eraser", "Eraser");
export const ExternalLink = /*#__PURE__*/ make("external-link", "ExternalLink");
export const Eye = /*#__PURE__*/ make("eye", "Eye");
export const EyeOff = /*#__PURE__*/ make("eye-off", "EyeOff");
export const Factory = /*#__PURE__*/ make("factory", "Factory");
export const FgBorders = /*#__PURE__*/ make("fg-borders", "FgBorders");
export const FgConditionalFormatting = /*#__PURE__*/ make("fg-conditional-formatting", "FgConditionalFormatting");
export const FgDot = /*#__PURE__*/ make("fg-dot", "FgDot");
export const FgGroup = /*#__PURE__*/ make("fg-group", "FgGroup");
export const FgPivotTable = /*#__PURE__*/ make("fg-pivot-table", "FgPivotTable");
export const FgSmartart = /*#__PURE__*/ make("fg-smartart", "FgSmartart");
export const FgStarFilled = /*#__PURE__*/ make("fg-star-filled", "FgStarFilled");
export const FgTableStyle = /*#__PURE__*/ make("fg-table-style", "FgTableStyle");
export const FgTransBars = /*#__PURE__*/ make("fg-trans-bars", "FgTransBars");
export const FgTransChecker = /*#__PURE__*/ make("fg-trans-checker", "FgTransChecker");
export const FgTransClock = /*#__PURE__*/ make("fg-trans-clock", "FgTransClock");
export const FgTransCut = /*#__PURE__*/ make("fg-trans-cut", "FgTransCut");
export const FgTransFade = /*#__PURE__*/ make("fg-trans-fade", "FgTransFade");
export const FgTransFlash = /*#__PURE__*/ make("fg-trans-flash", "FgTransFlash");
export const FgTransMorph = /*#__PURE__*/ make("fg-trans-morph", "FgTransMorph");
export const FgTransPush = /*#__PURE__*/ make("fg-trans-push", "FgTransPush");
export const FgTransRandom = /*#__PURE__*/ make("fg-trans-random", "FgTransRandom");
export const FgTransShape = /*#__PURE__*/ make("fg-trans-shape", "FgTransShape");
export const FgTransSplit = /*#__PURE__*/ make("fg-trans-split", "FgTransSplit");
export const FgTransWipe = /*#__PURE__*/ make("fg-trans-wipe", "FgTransWipe");
export const FgTransZoom = /*#__PURE__*/ make("fg-trans-zoom", "FgTransZoom");
export const FgWindowClose = /*#__PURE__*/ make("fg-window-close", "FgWindowClose");
export const FgWindowMaximize = /*#__PURE__*/ make("fg-window-maximize", "FgWindowMaximize");
export const FgWindowMinimize = /*#__PURE__*/ make("fg-window-minimize", "FgWindowMinimize");
export const FgWindowRestore = /*#__PURE__*/ make("fg-window-restore", "FgWindowRestore");
export const FgWordart = /*#__PURE__*/ make("fg-wordart", "FgWordart");
export const File = /*#__PURE__*/ make("file", "File");
export const FileArchive = /*#__PURE__*/ make("file-archive", "FileArchive");
export const FileAudio = /*#__PURE__*/ make("file-audio", "FileAudio");
export const FileChartColumn = /*#__PURE__*/ make("file-chart-column", "FileChartColumn");
export const FileCheck = /*#__PURE__*/ make("file-check", "FileCheck");
export const FileCode = /*#__PURE__*/ make("file-code", "FileCode");
export const FileDiff = /*#__PURE__*/ make("file-diff", "FileDiff");
export const FileDown = /*#__PURE__*/ make("file-down", "FileDown");
export const FileImage = /*#__PURE__*/ make("file-image", "FileImage");
export const FileInput = /*#__PURE__*/ make("file-input", "FileInput");
export const FileOutput = /*#__PURE__*/ make("file-output", "FileOutput");
export const FilePen = /*#__PURE__*/ make("file-pen", "FilePen");
export const FilePlus = /*#__PURE__*/ make("file-plus", "FilePlus");
export const FilePlus2 = /*#__PURE__*/ make("file-plus", "FilePlus2");
export const FileQuestion = /*#__PURE__*/ make("file-question", "FileQuestion");
export const FileSpreadsheet = /*#__PURE__*/ make("file-spreadsheet", "FileSpreadsheet");
export const FileText = /*#__PURE__*/ make("file-text", "FileText");
export const FileType = /*#__PURE__*/ make("file-type", "FileType");
export const FileType2 = /*#__PURE__*/ make("file-type", "FileType2");
export const FileUp = /*#__PURE__*/ make("file-up", "FileUp");
export const FileVideo = /*#__PURE__*/ make("file-video", "FileVideo");
export const FileX = /*#__PURE__*/ make("file-x", "FileX");
export const Files = /*#__PURE__*/ make("files", "Files");
export const Film = /*#__PURE__*/ make("film", "Film");
export const Filter = /*#__PURE__*/ make("filter", "Filter");
export const FilterX = /*#__PURE__*/ make("filter-x", "FilterX");
export const Fingerprint = /*#__PURE__*/ make("fingerprint", "Fingerprint");
export const Flag = /*#__PURE__*/ make("flag", "Flag");
export const FlagOff = /*#__PURE__*/ make("flag-off", "FlagOff");
export const FlipHorizontal = /*#__PURE__*/ make("flip-horizontal", "FlipHorizontal");
export const FlipHorizontal2 = /*#__PURE__*/ make("flip-horizontal", "FlipHorizontal2");
export const Focus = /*#__PURE__*/ make("focus", "Focus");
export const Folder = /*#__PURE__*/ make("folder", "Folder");
export const FolderInput = /*#__PURE__*/ make("folder-input", "FolderInput");
export const FolderOpen = /*#__PURE__*/ make("folder-open", "FolderOpen");
export const FolderPlus = /*#__PURE__*/ make("folder-plus", "FolderPlus");
export const FolderUp = /*#__PURE__*/ make("folder-up", "FolderUp");
export const FormInput = /*#__PURE__*/ make("form-input", "FormInput");
export const Forward = /*#__PURE__*/ make("forward", "Forward");
export const Frame = /*#__PURE__*/ make("frame", "Frame");
export const Fullscreen = /*#__PURE__*/ make("fullscreen", "Fullscreen");
export const FunctionSquare = /*#__PURE__*/ make("function-square", "FunctionSquare");
export const Gamepad2 = /*#__PURE__*/ make("gamepad-2", "Gamepad2");
export const GitCompare = /*#__PURE__*/ make("git-compare", "GitCompare");
export const Glasses = /*#__PURE__*/ make("glasses", "Glasses");
export const Globe = /*#__PURE__*/ make("globe", "Globe");
export const GraduationCap = /*#__PURE__*/ make("graduation-cap", "GraduationCap");
export const Grid2x2 = /*#__PURE__*/ make("grid-2x2", "Grid2x2");
export const Grid3x3 = /*#__PURE__*/ make("grid-3x3", "Grid3x3");
export const Grip = /*#__PURE__*/ make("grip", "Grip");
export const Group = /*#__PURE__*/ make("group", "Group");
export const Hand = /*#__PURE__*/ make("hand", "Hand");
export const Handshake = /*#__PURE__*/ make("handshake", "Handshake");
export const HardDrive = /*#__PURE__*/ make("hard-drive", "HardDrive");
export const HardDriveUpload = /*#__PURE__*/ make("hard-drive-upload", "HardDriveUpload");
export const Hash = /*#__PURE__*/ make("hash", "Hash");
export const Heading = /*#__PURE__*/ make("heading", "Heading");
export const Headset = /*#__PURE__*/ make("headset", "Headset");
export const Heart = /*#__PURE__*/ make("heart", "Heart");
export const HeartPulse = /*#__PURE__*/ make("heart-pulse", "HeartPulse");
export const HelpCircle = /*#__PURE__*/ make("circle-help", "HelpCircle");
export const Highlighter = /*#__PURE__*/ make("highlighter", "Highlighter");
export const History = /*#__PURE__*/ make("history", "History");
export const Home = /*#__PURE__*/ make("house", "Home");
export const House = /*#__PURE__*/ make("house", "House");
export const Image = /*#__PURE__*/ make("image", "Image");
export const ImageDown = /*#__PURE__*/ make("image-down", "ImageDown");
export const ImageIcon = /*#__PURE__*/ make("image", "ImageIcon");
export const ImageMinus = /*#__PURE__*/ make("image-minus", "ImageMinus");
export const ImagePlus = /*#__PURE__*/ make("image-plus", "ImagePlus");
export const Images = /*#__PURE__*/ make("images", "Images");
export const Import = /*#__PURE__*/ make("import", "Import");
export const Inbox = /*#__PURE__*/ make("inbox", "Inbox");
export const Indent = /*#__PURE__*/ make("indent", "Indent");
export const IndentDecrease = /*#__PURE__*/ make("indent-decrease", "IndentDecrease");
export const IndentIncrease = /*#__PURE__*/ make("indent-increase", "IndentIncrease");
export const Infinity = /*#__PURE__*/ make("infinity", "Infinity");
export const Info = /*#__PURE__*/ make("info", "Info");
export const Italic = /*#__PURE__*/ make("italic", "Italic");
export const Key = /*#__PURE__*/ make("key", "Key");
export const KeyRound = /*#__PURE__*/ make("key", "KeyRound");
export const Keyboard = /*#__PURE__*/ make("keyboard", "Keyboard");
export const Landmark = /*#__PURE__*/ make("landmark", "Landmark");
export const Languages = /*#__PURE__*/ make("languages", "Languages");
export const Laptop = /*#__PURE__*/ make("laptop", "Laptop");
export const Lasso = /*#__PURE__*/ make("lasso", "Lasso");
export const LassoSelect = /*#__PURE__*/ make("lasso-select", "LassoSelect");
export const Layers = /*#__PURE__*/ make("layers", "Layers");
export const Layout = /*#__PURE__*/ make("layout-template", "Layout");
export const LayoutDashboard = /*#__PURE__*/ make("layout-dashboard", "LayoutDashboard");
export const LayoutGrid = /*#__PURE__*/ make("layout-grid", "LayoutGrid");
export const LayoutPanelTop = /*#__PURE__*/ make("layout-panel-top", "LayoutPanelTop");
export const LayoutTemplate = /*#__PURE__*/ make("layout-template", "LayoutTemplate");
export const Library = /*#__PURE__*/ make("library", "Library");
export const LifeBuoy = /*#__PURE__*/ make("life-buoy", "LifeBuoy");
export const Lightbulb = /*#__PURE__*/ make("lightbulb", "Lightbulb");
export const LineChart = /*#__PURE__*/ make("chart-line", "LineChart");
export const Link = /*#__PURE__*/ make("link", "Link");
export const Link2 = /*#__PURE__*/ make("link", "Link2");
export const Link2Off = /*#__PURE__*/ make("unlink", "Link2Off");
export const List = /*#__PURE__*/ make("list", "List");
export const ListChecks = /*#__PURE__*/ make("list-checks", "ListChecks");
export const ListFilter = /*#__PURE__*/ make("list-filter", "ListFilter");
export const ListOrdered = /*#__PURE__*/ make("list-ordered", "ListOrdered");
export const ListPlus = /*#__PURE__*/ make("list-plus", "ListPlus");
export const ListTodo = /*#__PURE__*/ make("list-todo", "ListTodo");
export const ListTree = /*#__PURE__*/ make("list-tree", "ListTree");
export const Loader = /*#__PURE__*/ make("loader", "Loader");
export const Loader2 = /*#__PURE__*/ make("loader", "Loader2");
export const Lock = /*#__PURE__*/ make("lock", "Lock");
export const LockOpen = /*#__PURE__*/ make("lock-open", "LockOpen");
export const LogIn = /*#__PURE__*/ make("log-in", "LogIn");
export const LogOut = /*#__PURE__*/ make("log-out", "LogOut");
export const Mail = /*#__PURE__*/ make("mail", "Mail");
export const MailCheck = /*#__PURE__*/ make("mail-check", "MailCheck");
export const MailMinus = /*#__PURE__*/ make("mail-minus", "MailMinus");
export const MailOpen = /*#__PURE__*/ make("mail-open", "MailOpen");
export const Map = /*#__PURE__*/ make("map", "Map");
export const MapPin = /*#__PURE__*/ make("map-pin", "MapPin");
export const Maximize = /*#__PURE__*/ make("maximize", "Maximize");
export const Maximize2 = /*#__PURE__*/ make("maximize-2", "Maximize2");
export const Megaphone = /*#__PURE__*/ make("megaphone", "Megaphone");
export const Menu = /*#__PURE__*/ make("menu", "Menu");
export const Merge = /*#__PURE__*/ make("merge", "Merge");
export const MessageCircle = /*#__PURE__*/ make("message-circle", "MessageCircle");
export const MessageSquare = /*#__PURE__*/ make("message-square", "MessageSquare");
export const MessageSquareHeart = /*#__PURE__*/ make("message-square-heart", "MessageSquareHeart");
export const MessageSquarePlus = /*#__PURE__*/ make("message-square-plus", "MessageSquarePlus");
export const MessageSquareReply = /*#__PURE__*/ make("message-square-reply", "MessageSquareReply");
export const MessageSquareText = /*#__PURE__*/ make("message-square-text", "MessageSquareText");
export const MessageSquareX = /*#__PURE__*/ make("message-square-x", "MessageSquareX");
export const MessagesSquare = /*#__PURE__*/ make("messages-square", "MessagesSquare");
export const Mic = /*#__PURE__*/ make("mic", "Mic");
export const MicOff = /*#__PURE__*/ make("mic-off", "MicOff");
export const Minimize2 = /*#__PURE__*/ make("minimize-2", "Minimize2");
export const Minus = /*#__PURE__*/ make("minus", "Minus");
export const Monitor = /*#__PURE__*/ make("monitor", "Monitor");
export const MonitorCheck = /*#__PURE__*/ make("monitor-check", "MonitorCheck");
export const MonitorOff = /*#__PURE__*/ make("monitor-off", "MonitorOff");
export const MonitorPlay = /*#__PURE__*/ make("monitor-play", "MonitorPlay");
export const MonitorSmartphone = /*#__PURE__*/ make("monitor-smartphone", "MonitorSmartphone");
export const MonitorUp = /*#__PURE__*/ make("monitor-up", "MonitorUp");
export const Moon = /*#__PURE__*/ make("moon", "Moon");
export const MoreHorizontal = /*#__PURE__*/ make("ellipsis", "MoreHorizontal");
export const MoreVertical = /*#__PURE__*/ make("ellipsis-vertical", "MoreVertical");
export const Mouse = /*#__PURE__*/ make("mouse", "Mouse");
export const MousePointer = /*#__PURE__*/ make("mouse-pointer", "MousePointer");
export const MousePointer2 = /*#__PURE__*/ make("mouse-pointer", "MousePointer2");
export const MousePointerClick = /*#__PURE__*/ make("mouse-pointer-click", "MousePointerClick");
export const Move = /*#__PURE__*/ make("move", "Move");
export const Move3d = /*#__PURE__*/ make("move-3d", "Move3d");
export const MoveDown = /*#__PURE__*/ make("move-down", "MoveDown");
export const MoveHorizontal = /*#__PURE__*/ make("move-horizontal", "MoveHorizontal");
export const MoveRight = /*#__PURE__*/ make("move-right", "MoveRight");
export const MoveUp = /*#__PURE__*/ make("move-up", "MoveUp");
export const MoveUpRight = /*#__PURE__*/ make("move-up-right", "MoveUpRight");
export const MoveVertical = /*#__PURE__*/ make("move-vertical", "MoveVertical");
export const Music = /*#__PURE__*/ make("music", "Music");
export const Music2 = /*#__PURE__*/ make("music", "Music2");
export const Network = /*#__PURE__*/ make("network", "Network");
export const NotebookPen = /*#__PURE__*/ make("notebook-pen", "NotebookPen");
export const Omega = /*#__PURE__*/ make("omega", "Omega");
export const Outdent = /*#__PURE__*/ make("outdent", "Outdent");
export const Package = /*#__PURE__*/ make("package", "Package");
export const PackageOpen = /*#__PURE__*/ make("package-open", "PackageOpen");
export const PaintBucket = /*#__PURE__*/ make("paint-bucket", "PaintBucket");
export const Paintbrush = /*#__PURE__*/ make("paintbrush", "Paintbrush");
export const Palette = /*#__PURE__*/ make("palette", "Palette");
export const PanelBottom = /*#__PURE__*/ make("panel-bottom", "PanelBottom");
export const PanelLeft = /*#__PURE__*/ make("panel-left", "PanelLeft");
export const PanelLeftClose = /*#__PURE__*/ make("panel-left-close", "PanelLeftClose");
export const PanelLeftOpen = /*#__PURE__*/ make("panel-left-open", "PanelLeftOpen");
export const PanelRight = /*#__PURE__*/ make("panel-right", "PanelRight");
export const PanelRightClose = /*#__PURE__*/ make("panel-right-close", "PanelRightClose");
export const PanelRightOpen = /*#__PURE__*/ make("panel-right-open", "PanelRightOpen");
export const PanelTop = /*#__PURE__*/ make("panel-top", "PanelTop");
export const PanelsTopLeft = /*#__PURE__*/ make("panels-top-left", "PanelsTopLeft");
export const Paperclip = /*#__PURE__*/ make("paperclip", "Paperclip");
export const Pause = /*#__PURE__*/ make("pause", "Pause");
export const Pen = /*#__PURE__*/ make("pen", "Pen");
export const PenLine = /*#__PURE__*/ make("pen-line", "PenLine");
export const PenOff = /*#__PURE__*/ make("pen-off", "PenOff");
export const PenTool = /*#__PURE__*/ make("pen-tool", "PenTool");
export const Pencil = /*#__PURE__*/ make("pencil", "Pencil");
export const PencilLine = /*#__PURE__*/ make("pencil-line", "PencilLine");
export const Percent = /*#__PURE__*/ make("percent", "Percent");
export const Phone = /*#__PURE__*/ make("phone", "Phone");
export const PhoneOff = /*#__PURE__*/ make("phone-off", "PhoneOff");
export const Pi = /*#__PURE__*/ make("pi", "Pi");
export const PictureInPicture = /*#__PURE__*/ make("picture-in-picture", "PictureInPicture");
export const PictureInPicture2 = /*#__PURE__*/ make("picture-in-picture", "PictureInPicture2");
export const PieChart = /*#__PURE__*/ make("chart-pie", "PieChart");
export const Pilcrow = /*#__PURE__*/ make("pilcrow", "Pilcrow");
export const PilcrowLeft = /*#__PURE__*/ make("pilcrow-left", "PilcrowLeft");
export const PilcrowRight = /*#__PURE__*/ make("pilcrow-right", "PilcrowRight");
export const Pin = /*#__PURE__*/ make("pin", "Pin");
export const PinOff = /*#__PURE__*/ make("pin-off", "PinOff");
export const Plane = /*#__PURE__*/ make("plane", "Plane");
export const Play = /*#__PURE__*/ make("play", "Play");
export const PlayCircle = /*#__PURE__*/ make("circle-play", "PlayCircle");
export const Plug = /*#__PURE__*/ make("plug", "Plug");
export const Plus = /*#__PURE__*/ make("plus", "Plus");
export const PlusCircle = /*#__PURE__*/ make("circle-plus", "PlusCircle");
export const PlusSquare = /*#__PURE__*/ make("square-plus", "PlusSquare");
export const Pointer = /*#__PURE__*/ make("pointer", "Pointer");
export const Power = /*#__PURE__*/ make("power", "Power");
export const PowerOff = /*#__PURE__*/ make("power-off", "PowerOff");
export const Presentation = /*#__PURE__*/ make("presentation", "Presentation");
export const Printer = /*#__PURE__*/ make("printer", "Printer");
export const Quote = /*#__PURE__*/ make("quote", "Quote");
export const Radar = /*#__PURE__*/ make("radar", "Radar");
export const Radical = /*#__PURE__*/ make("radical", "Radical");
export const Radio = /*#__PURE__*/ make("radio", "Radio");
export const ReceiptText = /*#__PURE__*/ make("receipt-text", "ReceiptText");
export const RectangleHorizontal = /*#__PURE__*/ make("rectangle-horizontal", "RectangleHorizontal");
export const RectangleVertical = /*#__PURE__*/ make("rectangle-vertical", "RectangleVertical");
export const Redo2 = /*#__PURE__*/ make("redo-2", "Redo2");
export const RefreshCw = /*#__PURE__*/ make("refresh-cw", "RefreshCw");
export const RemoveFormatting = /*#__PURE__*/ make("remove-formatting", "RemoveFormatting");
export const Repeat = /*#__PURE__*/ make("repeat", "Repeat");
export const Replace = /*#__PURE__*/ make("replace", "Replace");
export const Reply = /*#__PURE__*/ make("reply", "Reply");
export const ReplyAll = /*#__PURE__*/ make("reply-all", "ReplyAll");
export const RotateCcw = /*#__PURE__*/ make("rotate-ccw", "RotateCcw");
export const RotateCw = /*#__PURE__*/ make("rotate-cw", "RotateCw");
export const Route = /*#__PURE__*/ make("route", "Route");
export const Rows2 = /*#__PURE__*/ make("rows-2", "Rows2");
export const Rows3 = /*#__PURE__*/ make("rows-3", "Rows3");
export const Ruler = /*#__PURE__*/ make("ruler", "Ruler");
export const Save = /*#__PURE__*/ make("save", "Save");
export const SaveAll = /*#__PURE__*/ make("save-all", "SaveAll");
export const Scale = /*#__PURE__*/ make("scale", "Scale");
export const Scaling = /*#__PURE__*/ make("scaling", "Scaling");
export const ScanLine = /*#__PURE__*/ make("scan-line", "ScanLine");
export const ScanSearch = /*#__PURE__*/ make("scan-search", "ScanSearch");
export const ScanText = /*#__PURE__*/ make("scan-text", "ScanText");
export const ScatterChart = /*#__PURE__*/ make("chart-scatter", "ScatterChart");
export const Scissors = /*#__PURE__*/ make("scissors", "Scissors");
export const ScrollText = /*#__PURE__*/ make("scroll-text", "ScrollText");
export const Search = /*#__PURE__*/ make("search", "Search");
export const Send = /*#__PURE__*/ make("send", "Send");
export const SendToBack = /*#__PURE__*/ make("send-to-back", "SendToBack");
export const SeparatorHorizontal = /*#__PURE__*/ make("separator-horizontal", "SeparatorHorizontal");
export const Server = /*#__PURE__*/ make("server", "Server");
export const ServerCog = /*#__PURE__*/ make("server-cog", "ServerCog");
export const ServerIcon = /*#__PURE__*/ make("server", "ServerIcon");
export const Settings = /*#__PURE__*/ make("settings", "Settings");
export const Settings2 = /*#__PURE__*/ make("sliders-vertical", "Settings2");
export const Shapes = /*#__PURE__*/ make("shapes", "Shapes");
export const Share = /*#__PURE__*/ make("share", "Share");
export const Share2 = /*#__PURE__*/ make("share", "Share2");
export const Sheet = /*#__PURE__*/ make("sheet", "Sheet");
export const Shield = /*#__PURE__*/ make("shield", "Shield");
export const ShieldAlert = /*#__PURE__*/ make("shield-alert", "ShieldAlert");
export const ShieldBan = /*#__PURE__*/ make("shield-ban", "ShieldBan");
export const ShieldCheck = /*#__PURE__*/ make("shield-check", "ShieldCheck");
export const ShieldOff = /*#__PURE__*/ make("shield-off", "ShieldOff");
export const ShieldQuestion = /*#__PURE__*/ make("shield-question", "ShieldQuestion");
export const ShoppingBag = /*#__PURE__*/ make("shopping-bag", "ShoppingBag");
export const ShoppingCart = /*#__PURE__*/ make("shopping-cart", "ShoppingCart");
export const Shuffle = /*#__PURE__*/ make("shuffle", "Shuffle");
export const Sigma = /*#__PURE__*/ make("sigma", "Sigma");
export const SignalHigh = /*#__PURE__*/ make("signal-high", "SignalHigh");
export const SignalLow = /*#__PURE__*/ make("signal-low", "SignalLow");
export const Signature = /*#__PURE__*/ make("signature", "Signature");
export const Siren = /*#__PURE__*/ make("siren", "Siren");
export const SkipBack = /*#__PURE__*/ make("skip-back", "SkipBack");
export const SkipForward = /*#__PURE__*/ make("skip-forward", "SkipForward");
export const SlidersHorizontal = /*#__PURE__*/ make("sliders-horizontal", "SlidersHorizontal");
export const SlidersVertical = /*#__PURE__*/ make("sliders-vertical", "SlidersVertical");
export const Smile = /*#__PURE__*/ make("smile", "Smile");
export const SmilePlus = /*#__PURE__*/ make("smile-plus", "SmilePlus");
export const Snowflake = /*#__PURE__*/ make("snowflake", "Snowflake");
export const Sparkles = /*#__PURE__*/ make("sparkles", "Sparkles");
export const Speech = /*#__PURE__*/ make("speech", "Speech");
export const SpellCheck = /*#__PURE__*/ make("spell-check", "SpellCheck");
export const Split = /*#__PURE__*/ make("split", "Split");
export const SplitSquareHorizontal = /*#__PURE__*/ make("square-split-horizontal", "SplitSquareHorizontal");
export const Square = /*#__PURE__*/ make("square", "Square");
export const SquareActivity = /*#__PURE__*/ make("square-activity", "SquareActivity");
export const SquareArrowOutUpRight = /*#__PURE__*/ make("square-arrow-out-up-right", "SquareArrowOutUpRight");
export const SquareCheck = /*#__PURE__*/ make("square-check", "SquareCheck");
export const SquareDashed = /*#__PURE__*/ make("square-dashed", "SquareDashed");
export const SquareFunction = /*#__PURE__*/ make("square-function", "SquareFunction");
export const SquarePen = /*#__PURE__*/ make("square-pen", "SquarePen");
export const SquarePlus = /*#__PURE__*/ make("square-plus", "SquarePlus");
export const SquareSplitHorizontal = /*#__PURE__*/ make("square-split-horizontal", "SquareSplitHorizontal");
export const SquareStack = /*#__PURE__*/ make("square-stack", "SquareStack");
export const Star = /*#__PURE__*/ make("star", "Star");
export const StarOff = /*#__PURE__*/ make("star-off", "StarOff");
export const Sticker = /*#__PURE__*/ make("sticker", "Sticker");
export const StickyNote = /*#__PURE__*/ make("sticky-note", "StickyNote");
export const Strikethrough = /*#__PURE__*/ make("strikethrough", "Strikethrough");
export const Subscript = /*#__PURE__*/ make("subscript", "Subscript");
export const Sun = /*#__PURE__*/ make("sun", "Sun");
export const SunDim = /*#__PURE__*/ make("sun-dim", "SunDim");
export const Superscript = /*#__PURE__*/ make("superscript", "Superscript");
export const SwatchBook = /*#__PURE__*/ make("swatch-book", "SwatchBook");
export const Table = /*#__PURE__*/ make("table", "Table");
export const Table2 = /*#__PURE__*/ make("table", "Table2");
export const TableCellsMerge = /*#__PURE__*/ make("table-cells-merge", "TableCellsMerge");
export const TableOfContents = /*#__PURE__*/ make("table-of-contents", "TableOfContents");
export const TableProperties = /*#__PURE__*/ make("table-properties", "TableProperties");
export const Tag = /*#__PURE__*/ make("tag", "Tag");
export const Tags = /*#__PURE__*/ make("tags", "Tags");
export const Target = /*#__PURE__*/ make("target", "Target");
export const TerminalSquare = /*#__PURE__*/ make("terminal-square", "TerminalSquare");
export const TextCursorInput = /*#__PURE__*/ make("text-cursor-input", "TextCursorInput");
export const Timer = /*#__PURE__*/ make("timer", "Timer");
export const TimerOff = /*#__PURE__*/ make("timer-off", "TimerOff");
export const Trash2 = /*#__PURE__*/ make("trash-2", "Trash2");
export const TrendingUp = /*#__PURE__*/ make("trending-up", "TrendingUp");
export const TriangleAlert = /*#__PURE__*/ make("triangle-alert", "TriangleAlert");
export const Trophy = /*#__PURE__*/ make("trophy", "Trophy");
export const Type = /*#__PURE__*/ make("type", "Type");
export const Underline = /*#__PURE__*/ make("underline", "Underline");
export const Undo2 = /*#__PURE__*/ make("undo-2", "Undo2");
export const Ungroup = /*#__PURE__*/ make("ungroup", "Ungroup");
export const Unlink = /*#__PURE__*/ make("unlink", "Unlink");
export const Unlock = /*#__PURE__*/ make("unlock", "Unlock");
export const Upload = /*#__PURE__*/ make("upload", "Upload");
export const User = /*#__PURE__*/ make("user", "User");
export const UserCheck = /*#__PURE__*/ make("user-check", "UserCheck");
export const UserPlus = /*#__PURE__*/ make("user-plus", "UserPlus");
export const UserRound = /*#__PURE__*/ make("user-round", "UserRound");
export const UserX = /*#__PURE__*/ make("user-x", "UserX");
export const Users = /*#__PURE__*/ make("users", "Users");
export const UsersRound = /*#__PURE__*/ make("users-round", "UsersRound");
export const Variable = /*#__PURE__*/ make("variable", "Variable");
export const Video = /*#__PURE__*/ make("video", "Video");
export const VideoOff = /*#__PURE__*/ make("video-off", "VideoOff");
export const View = /*#__PURE__*/ make("view", "View");
export const Volume2 = /*#__PURE__*/ make("volume-2", "Volume2");
export const VolumeX = /*#__PURE__*/ make("volume-x", "VolumeX");
export const Wand2 = /*#__PURE__*/ make("wand-sparkles", "Wand2");
export const WandSparkles = /*#__PURE__*/ make("wand-sparkles", "WandSparkles");
export const Waves = /*#__PURE__*/ make("waves", "Waves");
export const Waypoints = /*#__PURE__*/ make("waypoints", "Waypoints");
export const Wifi = /*#__PURE__*/ make("wifi", "Wifi");
export const WifiOff = /*#__PURE__*/ make("wifi-off", "WifiOff");
export const Workflow = /*#__PURE__*/ make("workflow", "Workflow");
export const WrapText = /*#__PURE__*/ make("wrap-text", "WrapText");
export const X = /*#__PURE__*/ make("x", "X");
export const XCircle = /*#__PURE__*/ make("circle-x", "XCircle");
export const Zap = /*#__PURE__*/ make("zap", "Zap");
export const ZoomIn = /*#__PURE__*/ make("zoom-in", "ZoomIn");
export const ZoomOut = /*#__PURE__*/ make("zoom-out", "ZoomOut");
